import React from "react";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
import wretch from "wretch";

import styles from "./styles.m.css";

const cookies = new Cookies();

export class MailPush extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newsletter: new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(cookies.get("vikatan[email]"))
        ? cookies.get("vikatan[email]")
        : "",
      msg: "",
      status: 0,
      inputValid: true,
      newsletterView: false
    };
    this.configureData = this.configureData.bind(this);
    this.updateTemplateAttribute = this.updateTemplateAttribute.bind(this);
  }

  updateTemplateAttribute(name, value) {
    this.setState({
      [name]: value,
      inputValid: true
    });
  }

  configureData() {
    const vuid = cookies.get("vuid");
    const itself = this;
    const current = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(current.getFullYear() + 1);

    const req = {
      email: this.state.newsletter,
      url: "flames",
      vuid: vuid || ""
    };

    if (new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.newsletter) === false) {
      itself.setState({
        inputValid: false
      });
      return false;
    }

    wretch(`https://special.vikatan.com/newsletter/event_participants.php`)
      .query({ ...req })
      .get()
      .json(res => {
        console.log(res);
        itself.setState({
          msg: "நன்றி. விரைவில் சிறப்புப் பரிசுடன் உங்களை‌ தொடர்பு கொள்வோம்.",
          newsletterView: false,
          status: 1
        });

        setTimeout(() => {
          itself.setState({
            newsletterView: true
          });
        }, 4000);
      });
  }

  render() {
    const { msg, newsletterView, status, inputValid } = this.state;
    const emailClass = inputValid ? "email" : "error-email";
    const { className, color } = this.props;

    return (
      <div className={className} style={color && { "--accent-color": color }}>
        {status !== "0" ? (
          <div className={styles["newsLetter-container"]}>
            <div styleName="widget-header" className={styles["component-wrapper"]}>
              <div className={styles["content-sec"]}>
                <p className={styles["widget-description"]}>
                  ஹாய். உங்களுக்காக ஒரு காதலர் தின சர்ப்ரைஸ் பரிசு காத்திருக்கு. மெயில் ஐடி மூலம் பதிவு பண்ணுங்க.
                  சீக்கிரமே இன்பாக்ஸ்ல வர்றோம்!
                </p>
              </div>
              <div className={styles["from-outer-sec"]}>
                <input
                  type="email"
                  placeholder={"Enter Email ID & Get Vikatan Gift"}
                  value={this.state.newsletter}
                  onChange={e => this.updateTemplateAttribute("newsletter", e.target.value)}
                  ref={input => {
                    this.nameInput = input;
                  }}
                  className={styles[emailClass]}
                />
                <div className={styles["input-wrapper-submit"]}>
                  <a
                    aria-label="submit"
                    role="button"
                    className={styles["submit-configure"]}
                    onClick={this.configureData}
                  >
                    Submit
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {newsletterView === false && msg ? (
          <div className={styles["newsLetter-error-container"]}>
            <div className={styles["errorInfo"]}>{msg}</div>
          </div>
        ) : (
          " "
        )}
      </div>
    );
  }
}

export default MailPush;

MailPush.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string
  }),
  className: PropTypes.string,
  color: PropTypes.string
};
